export const isAppVersionAtLeast = (
  version: string,
  minimumVersion: string,
) => {
  const versionParts = version.split('.').map(Number);
  const minimumVersionParts = minimumVersion.split('.').map(Number);

  const partCount = Math.max(versionParts.length, minimumVersionParts.length);

  for (let partIndex = 0; partIndex < partCount; partIndex += 1) {
    const versionPart = versionParts[partIndex] ?? 0;
    const minimumVersionPart = minimumVersionParts[partIndex] ?? 0;

    if (versionPart !== minimumVersionPart)
      return versionPart > minimumVersionPart;
  }

  return true;
};
